import { useCallback } from "react"

import { useUrlParams } from "../utils/useUrlParams"

import { useNavigate } from "./useNavigate"

export function useNavigateWithSearchParams() {

    const { getParams } = useUrlParams()
    const navigate = useNavigate()
    const searchParams = getParams()

    const navigateWithSearchParams = useCallback((url, options = {}) => {
        const {
            paramsToDelete,
            ...otherOptions
        } = options
        if (paramsToDelete?.length) {
            paramsToDelete.forEach(paramToDelete => {
                searchParams.delete(paramToDelete)
            })
        }
        navigate(
            { pathname: url, search: searchParams.toString() },
            { ...otherOptions },
        )
    }, [searchParams, navigate])

    return navigateWithSearchParams
}